import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  quoteItemsTable,
  salesOrderItemsTable,
} from "../../../config/grid-column-defs";
import { getTransactionItems } from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, FormControlLabel, FormGroup, Grid } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { GridComp12, GridComp126 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import {
  getTransactionQuoteEstimateItemDetail,
} from "../../../api/invoice";

export default function QuoteItems({setSum}) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState({});

  async function getTransactionItemsData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionQuoteEstimateItemDetail(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data);
      setSum(data.data.itemsum)
      setLoading(false);
      return {
        rows: data.data.items,
        total: data.data.itemtotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox">
        <Grid container className="mb-2">
          <GridComp12 title={"DISCOUNT ITEM"} data={rowData.discount} />
          <GridComp126 title={"RATE"} data={rowData.rate} />
          <CustomCheckBoxComp126
            title={"TAX DATE OVERRIDE"}
            data={rowData.tax_date_override}
          />
          <CustomCheckBoxComp126
            title={"TAX OVERRIDE"}
            data={rowData.tax_override}
          />
        
          <GridComp126
            title={"AVATAX OVERRIDE DATE"}
            data={rowData.avatax_override_date}
          />
        </Grid>
        <AgGridPaginatedTable
          getTableRows={getTransactionItemsData}
          columns={quoteItemsTable}
          perPage={10}
          refreshCounter={0}
        />
      </Box>
    </>
  );
}
